import Container from '@/components/@base/container';
import localization from '@/constant/localization';
import { Text } from '@/components/@base/typography';
import PaymentInputShape from '@/components/payment-with-id/paymentInputShape';
import useUserWalletsVouchersStore from '@/store/user-wallets-store';
import emptyList from "@/assets/images/empty-assets-list.svg";
import emptyListDark from "@/assets/images/empty-assets-list-dark.svg";
const PaymentWithId = () => {
  const { segments, usableClientVouchers, isSegmentLoading } = useUserWalletsVouchersStore();
  if(isSegmentLoading) return null;
  if(segments.length === 0 && usableClientVouchers.length === 0) return (
    <Container center className="flex-col pt-7 pb-3 px-10 gap-1">
      <img src={emptyList} width={120} height={120} alt="" className="dark:hidden"/>
      <img src={emptyListDark} width={120} height={120} alt="" className="hidden dark:block"/>
      <Text className="text-grayLight-650 dark:text-grayLight-300 text-md text-center leading-7">{localization.userPaymentHint}</Text>
    </Container>
  )
  return (
    <Container className="px-3 mt-7">
      <Text className='text-lg text-grayLight-1000 dark:text-grayLight-0 mb-4 leading-8' medium>
        {localization.PayWithId}
      </Text>
        <PaymentInputShape/>
    </Container>
  )
}
export default PaymentWithId